// LEGACY UI: replace with Dialog from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import ControlsChevronLeft from "@casino/external/icons/ControlsChevronLeft";
import ControlsClose from "@casino/external/icons/ControlsClose";
import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import Translate from "@casino/legacy/client/shared/i18n/Translate";
import rem from "@casino/legacy/client/shared/rem";
import { DialogTitle } from "@workspace/frontend-ui";
import DesktopDialog from "./DesktopDialog";
import MobileDialog from "./MobileDialog";

type Props = {
  onClose: () => void;
  title?: string;
  onClickBack?: () => void;
};

const Dialog: FC<Props> = ({ children, onClose, title, onClickBack }) => {
  const { isMobile } = useAgentData();
  const header = (
    <DialogTitle>
      <div className="flex w-full items-start justify-between border-b-[0.5px] border-border px-4 py-6 text-foreground text-lg font-medium">
        {onClickBack && (
          <div className="mr-2 min-w-8 cursor-pointer">
            <ControlsChevronLeft
              fontSize={rem(16)}
              onClick={onClickBack}
              data-testid="back-button"
            />
          </div>
        )}
        <div>{title && <Translate id={title} />}</div>
        <div className="ml-2 flex cursor-pointer items-center">
          <ControlsClose
            fontSize={rem(16)}
            onClick={onClose}
            data-testid="close-button"
          />
        </div>
      </div>
    </DialogTitle>
  );
  if (isMobile) {
    return (
      <MobileDialog onClose={onClose}>
        {header}
        <div className="grid pt-4 px-6 pb-6 gap-6" data-testid="2FA-dialog">
          {children}
        </div>
      </MobileDialog>
    );
  }
  return (
    <DesktopDialog onClose={onClose} header={header}>
      <div className="grid pt-4 px-6 pb-6 gap-6" data-testid="2FA-dialog">
        {children}
      </div>
    </DesktopDialog>
  );
};

export default Dialog;
